<template>
  <div class="feature-more mt-12">
    <v-container>
      <div class="section-kicker-bar text-center mb-2">
        <v-chip small color="primary" outlined class="kicker-chip">
          <v-icon small left>mdi-layers-triple-outline</v-icon>
          {{ $t('header.services') }}
        </v-chip>
      </div>
      <h1 class="my-4 text-center title-style">{{ $t("landing.servicesTitle") }}</h1>
      <p class="feature-subtitle text-center mb-10">
        {{ $t('landing.servicesDesc') }}
      </p>

      <div id="services" class="services-grid-wrap" :class="{ 'rtl-content': isRTL }">
        <v-row class="services-grid mx-0 mx-sm-1">
          <v-col
            v-for="(item, index) in services"
            :key="index"
            cols="12"
            sm="6"
            lg="6"
            class="d-flex"
          >
            <u-animate-container v-if="loaded" class="service-grid-item w-100">
              <u-animate :name="isRTL ? 'fadeInRight' : 'fadeInLeft'" :delay="`${0.1 * (index % 4)}s`" duration="0.55s">
                <v-card class="service-card" elevation="0" hover>
                  <div class="service-card-accent"></div>
                  <div class="service-card-inner">
                    <div class="service-media mb-5">
                      <img :src="item.img" draggable="false" :alt="item.title" class="service-media-img" />
                    </div>
                    <h3 class="service-title mb-3">{{ item.title }}</h3>
                    <p class="service-text mb-6">{{ item.body }}</p>
                    
                    <div class="service-card-footer d-flex align-center justify-space-between flex-wrap">
                      <v-btn
                        :to="localePath(item.url)"
                        outlined
                        color="primary"
                        class="service-btn"
                      >
                        {{ $t('landing.explorer') }}
                        <v-icon right>
                          {{ isRTL ? 'mdi-arrow-left' : 'mdi-arrow-right' }}
                        </v-icon>
                      </v-btn>
                      
                      <v-btn
                        :to="localePath('/contact')"
                        text
                        color="secondary"
                        class="service-order-link px-0"
                      >
                        {{ $t('apps.pricingOrder') }}
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </u-animate>
            </u-animate-container>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<style scoped lang="scss">
@import "./feature-styles";

.service-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.service-card-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px 24px;
}

.service-text {
  flex-grow: 1;
}

.service-card-footer {
  margin-top: auto;
  gap: 12px;
}
</style>

<script>
export default {
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    services() {
      return this.$t("services");
    },
    isRTL() {
      return this.$i18n.locale === 'ar' || this.$vuetify?.rtl;
    }
  },
  mounted() {
    this.loaded = true;
  },
  data() {
    return {
      loaded: false
    };
  }
};
</script>

